import AURDAL from './AURDAL';
import BOAXEL from './BOAXEL';
import BROR from './BROR';
import IVAR from './IVAR';
import JONAXEL from './JONAXEL';
import ELVARLI from './ELVARLI';

export default {
  AURDAL,
  BOAXEL,
  BROR,
  IVAR,
  JONAXEL,
  ELVARLI,
};
